import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const Sheet = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 1.6rem;
  padding: 2.8rem;
  width: 100%;
  max-width: 48rem;
  max-height: 90vh;
  overflow-y: auto;
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.6rem;
`;

export const Title = styled.span`
  font-size: 2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
`;

export const CloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.slateGrey};
`;

export const ResponseHint = styled.div<{ $accent: string }>`
  font-size: 1.3rem;
  color: ${({ $accent }) => $accent};
  font-weight: 600;
  margin-bottom: 1.6rem;
  background-color: ${({ $accent }) => `${$accent}1A`};
  padding: 0.6rem 1.2rem;
  border-radius: 0.8rem;
`;

export const Label = styled.label`
  display: block;
  font-size: 1.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.slate};
  margin-top: 1.2rem;
  margin-bottom: 0.4rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
`;

export const ServiceRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-top: 0.4rem;
`;

export const ServiceChip = styled.button<{
  $selected: boolean;
  $accent: string;
}>`
  border: 0.1rem solid
    ${({ $selected, $accent, theme }) =>
      $selected ? $accent : theme.colors.border};
  border-radius: 1.6rem;
  padding: 0.6rem 1.2rem;
  font-size: 1.2rem;
  font-weight: ${({ $selected }) => ($selected ? 700 : 600)};
  color: ${({ $selected, theme }) =>
    $selected ? theme.colors.white : theme.colors.slateGrey};
  background-color: ${({ $selected, $accent, theme }) =>
    $selected ? $accent : theme.colors.white};
  cursor: pointer;
  font-family: inherit;
`;

export const ErrorText = styled.div`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.errorDark};
  background-color: ${({ theme }) => theme.colors.errorBg};
  padding: 0.8rem 1.2rem;
  border-radius: 0.8rem;
  margin-top: 1.2rem;
`;

export const PrimaryBtn = styled.button<{ $accent: string }>`
  width: 100%;
  border: none;
  border-radius: 1.2rem;
  padding: 1.2rem 1.6rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ $accent }) => $accent};
  cursor: pointer;
  margin-top: 1.6rem;
  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
    cursor: not-allowed;
  }
`;

export const SuccessBox = styled.div`
  text-align: center;
  padding: 1.6rem 0;
`;

export const SuccessIcon = styled.div<{ $accent: string }>`
  width: 5.6rem;
  height: 5.6rem;
  border-radius: 50%;
  background-color: ${({ $accent }) => $accent};
  color: ${({ theme }) => theme.colors.white};
  font-size: 3rem;
  margin: 0 auto 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SuccessTitle = styled.div`
  font-size: 2rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin-bottom: 0.8rem;
`;

export const SuccessText = styled.p`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.slate};
  line-height: 1.5;
  margin-bottom: 1.2rem;
`;

export const LinkBox = styled.div`
  background-color: ${({ theme }) => theme.colors.surfaceSoft};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  border-radius: 1rem;
  padding: 1.4rem;
  margin-bottom: 1.6rem;
  text-align: left;
`;

export const LinkLabel = styled.div`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-transform: uppercase;
  margin-bottom: 0.6rem;
`;

export const LinkUrl = styled.a<{ $accent: string }>`
  font-size: 1.3rem;
  color: ${({ $accent }) => $accent};
  word-break: break-all;
`;
